var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDurationClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.8125C14.3147 17.8125 17.8125 14.3147 17.8125 10C17.8125 5.68528 14.3147 2.1875 10 2.1875C5.68528 2.1875 2.1875 5.68528 2.1875 10C2.1875 14.3147 5.68528 17.8125 10 17.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.8125C14.3147 17.8125 17.8125 14.3147 17.8125 10C17.8125 5.68528 14.3147 2.1875 10 2.1875C5.68528 2.1875 2.1875 5.68528 2.1875 10C2.1875 14.3147 5.68528 17.8125 10 17.8125Z",
    stroke: "#444B54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7656 12.7656L10 10L13.8594 6.14062",
    stroke: "#444B54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H4.53125",
    stroke: "#FF5576",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0938C10.6041 11.0938 11.0938 10.6041 11.0938 10C11.0938 9.39594 10.6041 8.90625 10 8.90625C9.39594 8.90625 8.90625 9.39594 8.90625 10C8.90625 10.6041 9.39594 11.0938 10 11.0938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0938C10.6041 11.0938 11.0938 10.6041 11.0938 10C11.0938 9.39594 10.6041 8.90625 10 8.90625C9.39594 8.90625 8.90625 9.39594 8.90625 10C8.90625 10.6041 9.39594 11.0938 10 11.0938Z",
    stroke: "#444B54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationClock);
export default __webpack_public_path__ + "static/media/duration-clock.d0d9e4819c263cf04d5dd549dd3687c6.svg";
export { ForwardRef as ReactComponent };